module.exports = __webpack_public_path__ + "img/ubm-logoNew.1b31b965.png";